import classNames from "classnames";
import "./Hr.css";

type Props = {
    className?: string;
};

type BaseHr = (className?: string) => (props: Props) => React.JSX.Element;

function BaseHr(baseClassName?: string) {
    return function Hr(props: Props) {
        const { className } = props;
        return <hr className={classNames("hr", baseClassName, className)} />;
    };
}

function Add(baseHr: BaseHr, className: string) {
    return (newClassName?: string) => baseHr(classNames(className, newClassName));
}

const Colors = (baseComponent: BaseHr) =>
    Object.assign(baseComponent(), {
        N10: baseComponent("hr--n10"),
        N20: baseComponent("hr--n20"),
        N50: baseComponent("hr--n50"),
        N60: baseComponent("hr--n60"),
        N100: baseComponent("hr--n100"),
    });

const Sizes = (baseComponent: BaseHr) =>
    Object.assign(baseComponent(), {
        XXLarge: Colors(Add(baseComponent, "hr--xxlarge")),
        XLarge: Colors(Add(baseComponent, "hr--xlarge")),
        Large: Colors(Add(baseComponent, "hr--large")),
        Medium: Colors(Add(baseComponent, "hr--medium")),
        Small: Colors(Add(baseComponent, "hr--small")),
        XSmall: Colors(Add(baseComponent, "hr--xsmall")),
        XXSmall: Colors(Add(baseComponent, "hr--xxsmall")),
    });

const Hr = Sizes(BaseHr);

export default Hr;
